import { render, staticRenderFns } from "./studentDetails.vue?vue&type=template&id=01781544"
import script from "./studentDetails.vue?vue&type=script&lang=js"
export * from "./studentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports